import { DimensionDescriptor, ItemDataType, ReportType } from "../../../shared/reporting/api/biClient.types";
import {
  isChartReportType,
  isPivotReportType,
  isTabularReportType,
  isTileReportType,
} from "../../../shared/reporting/utils/reportTypeHelper";

export const filterDimensions = (reportType: ReportType | undefined, dimensions: DimensionDescriptor[]) => {
  if (!reportType) {
    return dimensions;
  }
  if (isTabularReportType(reportType) || isTileReportType(reportType)) {
    return dimensions;
  }
  if (isPivotReportType(reportType) || isChartReportType(reportType)) {
    return dimensions.filter((d) => d.type === ItemDataType.Date || d.type === ItemDataType.General);
  }
  throw new Error(`Unsupported report type: ${reportType}`);
};
